<script lang="ts" setup>
import type { DetailsCarItemDetails } from '@autobid/ui/types/components/CarDetails'
import { usePrepareDetailsCarData } from '@autobid/ui/composables/car/usePrepareDetailsCarData'
import { computed } from 'vue'

interface Props {
  details: DetailsCarItemDetails
}

const props = defineProps<Props>()
const { specialExtras } = usePrepareDetailsCarData(
  computed(() => props.details),
)

const extras = computed(() => props.details?.specialExtras?.extras ?? [])

const classes = computed(() => {
  const result = {
    wrapper: 'col-span-12 lg:col-span-6',
    element: 'w-full sm:w-1/2',
  }

  return result
})
</script>

<template>
  <div v-if="specialExtras.display" :class="classes.wrapper">
    <SectionsDetailsElementsSection>
      <template #heading>
        {{ specialExtras.title }}
      </template>

      <template #content>
        <SectionsDetailsElementsList
          :elements="extras"
          :element-class="classes.element"
          :class="classes.element ? 'flex flex-row flex-wrap' : ''"
        />
      </template>
    </SectionsDetailsElementsSection>
  </div>
</template>
